import moment from "moment";

function bailIfEmpty(response) {
    if (typeof response != 'object') {
         return {}
     } else {
        return response;
    }
}



export default {
	login(response) {
	 
		response.data.permissions_list = response.data.permission.map(d => d.name);
		console.log("USER DATA: ", response.data);
		return response.data
	},

}



